import { Component, ElementRef, OnInit, Renderer2, HostListener, ViewChild, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import * as $ from 'jquery';
import { LogoutService } from '../../services/authservices/logout.service';
import Swal from 'sweetalert2';
import { AddService } from '../../services/userservices/add.service';
import { SharedModeService } from '../../services/shared-mode.service';
import { DashboardService } from '../../services/dashboardservices/dashboard.service';
import { DeviceUuidService } from '../../services/deviceuuidservices/device-uuid.service';
import { CommonModule, DatePipe } from '@angular/common';
import { SocketService } from '../../services/socket/socket.service';
import { FormsModule, NgForm } from '@angular/forms';
import { LeaveService } from '../../services/leaveservices/leave.service';
import { SettingservicesService } from '../../services/settingservices/settingservices.service';
import { LoaderComponent } from '../../components/loader/loader.component';
@Component({
  selector: 'app-sidebar-1',
  templateUrl: './sidebar-1.component.html',
  styleUrls: ['./sidebar-1.component.css'],
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule, LoaderComponent],
  providers: [DatePipe],
})

export class Sidebar1Component implements OnInit, OnDestroy {
  isSidebarVisible = false;
  isDropdownVisible = false;
  isOrgdownVisible = false;
  // visibleRoutes: string[] = ['/dashboard-1', '/another-page']; // Add routes where the sidebar should be visible
  resignation: any;
  user: any;
  refresh: any;
  resignationapi: any;
  resign_status: any;
  todayDate: any;
  todayDay: any;
  todayMonth: any;
  formattedDate: any;
  public showSpinner = true;
  showSubList = false;
  theme_id: any;
  count: any;
  // notify: any;
  notify = { count: 0 };
  lonecount: any;
  // loannotification: any;
  loannotification = { total_count: 0 };
  user_role: any;
  attendcount: any;
  // Attendanceotificaton: any;
  Attendanceotificaton = { total_count: 0 };

  attendancecount: any;
  clickListener: any;
  isMenuVisible = true;
  isManagemntVisible = true;
  isNotifyOpen = false;
  notifyData: any;
  notifylist: any;
  notify_counts: any;
  totalCount: any;
  showAdmintab = false;
  EmployeeTab = false;
  @ViewChild('dropdownRef') dropdownRef!: ElementRef;

  leaveselectedId: any;
  RejectionData: any;
  acceptanceData: any;
  reason1: any;
  reasonModal: any;
  leavedata: any;
  leaveReject: any;
  leaveaccept: any;
  notify_id: any;
  isSubMenuOpen = false;
  showorgSubList = false;
  orgnizations: any;
  onlyAdmin = false;


  constructor(
    private __logoutservice: LogoutService,
    private router: Router,
    private addService: AddService,
    private sharedMode: SharedModeService,
    public dashboardService: DashboardService,
    private deviceUuidService: DeviceUuidService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private datePipe: DatePipe,
    private socket: SocketService,
    private leaveService: LeaveService,
    private settings: SettingservicesService,

  ) {

  }

  ngOnInit(): void {
    // this.router.events
    //   .pipe(filter((event: any) => event instanceof NavigationEnd))
    //   .subscribe(() => {
    //     const currentRoute = this.router.url;
    //     this.isSidebarVisible = this.visibleRoutes.includes(currentRoute); // Show sidebar if current route is in visibleRoutes array
    //   });
    const userInfo = localStorage.getItem('user');

    const resignInfo = localStorage.getItem('resignation');
    if (resignInfo != null && resignInfo != "undefined") {
      this.resignation = JSON.parse(localStorage.getItem('resignation') || "");
    }
    if (userInfo != null) {
      this.user = JSON.parse(localStorage.getItem('user') || '') || '';
    }
    this.theme_id = localStorage.getItem('theme_id');
    if (this.theme_id === 2) {
      this.renderer.addClass(document.body, 'dark-theme');
    } else {
      this.renderer.removeClass(document.body, 'dark-theme');
    }
    this.user_refresh();
    const user_role = JSON.parse(this.user.user_role.user_roles)

    if(user_role.role_type == "Admin"){
      this.onlyAdmin = true; 
    }


    if (user_role.role_type == "Admin" || user_role.role_type == "Admin_AND_Team_Lead") {
      this.showAdmintab = true;
      this.EmployeeTab = false;
    } else if (user_role.role_type == "Employee") {
      this.showAdmintab = false;
      this.EmployeeTab = true;
    }
    this.socketRun();
    this.getNotifiations();

    this.isMangement();

    // this.isTeamAdmin();
    // this.isTeamUser();
    this.isEmployeeNot();
    this.isTeamManagement();
    this.isLeaveManagement();
    this.isEvent();
    this.isTeamEvaluation();
    this.isTeamResign();
    this.isTeamHoliday();
    this.isTeamMedia();
    this.isAttendeanceManagement();
    this.Shownotificaton(this.count);
    this.isSettingManagement();

    this.Loannotificaton(this.lonecount);
    this.Attendancenotificaton(this.attendancecount);
    this.isActionPermission();
    this.getTextForAutomation();

  }
  isMangement(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles)

    if (user_role.role_type === "Admin" || user_role.role_type === "Team_Lead" || user_role.role_type === "Admin_AND_Team_Lead") {
      return true
    }
    else {
      return false
    }
  }

  isEmployeeNot(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles)

    if (user_role.role_type == "Admin") {
      return true
    }
    else {
      return false
    }
  }

  isavailablefeatureforLeave(type: string): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);
    const values = user_role?.leave_data?.data?.values;

    switch (type) {
      case "isView":
        return values?.view_leave ?? false;

      case "isAccept":
        return values?.accept ?? false;

      case "isReject":
        return values?.reject ?? false;

      default:
        return false;
    }
  }
  // isTeamManagement(): boolean {
  //   var user_role = JSON.parse(this.user.user_role.user_roles)
  //   if (user_role.role_type === "Employee") {
  //     return false
  //   } else if (user_role.role_type === "Team_Lead") {
  //     return true
  //   } else if (user_role.role_type === "Admin_AND_Team_Lead") {
  //     return true
  //   } else if (user_role.role_type === "Admin") {
  //     return true
  //   } else {
  //     return user_role.team_managment.team_management ?? false
  //   }
  // }
  isTeamManagement(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);

    const allowedRoles = ["Team_Lead", "Admin_AND_Team_Lead", "Admin"];
    const hasTeamManagement = user_role.team_managment?.team_management ?? false;

    return allowedRoles.includes(user_role.role_type) && hasTeamManagement;
  }
  isLeaveManagement(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles)

    if (user_role.role_type === "Employee") {
      return false
    }

    else {
      return user_role.leave_data.leave_management ?? false
    }
  }
  isSettingManagement(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles)

    if (user_role.role_type === "Employee") {
      return false
    }

    else {
      return user_role.settings.setting ?? false
    }
  }
  // team evaluation
  isEvent(): boolean {
    
    const user_role = JSON.parse(this.user.user_role.user_roles)

    if (user_role.role_type === "Employee") {
      return false
    } else {
      return user_role.event_data?.event_managment ?? false
    }
  }


  // team evaluation
  isTeamEvaluation(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type === "Employee") {
      return false
    } else if (user_role.role_type === "Team_Lead") {
      return true
    } else if (user_role.role_type === "Admin_AND_Team_Lead") {
      return true
    } else {
      return user_role.team_evaluation.evaluation ?? false
    }
  }


  isTeamResign(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type === "Employee") {
      return false
    } else {
      return user_role.resign_data.resign ?? false
    }
  }

  // holidays
  isTeamHoliday(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type === "Employee") {
      return false
    } else {
      return user_role.holdays_data.holidays ?? false
    }
  }

  isSetting() {
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type === "Employee") {
      return false
    } else {
      return user_role.holdays_data.holidays ?? false
    }
  }
  isAttendeanceManagement(): boolean {

    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type === "Employee") {
      return false
    } else {
      return user_role.attendance_data.attentance_management ?? false
    }
  }

  isAccountManagement(): boolean {
    const user_role = JSON.parse(this.user?.user_role.user_roles)
    if (user_role.role_type === "Employee") {
      return false
    } else {
      return user_role?.account_data?.account_managment ?? false
    }
  }
  Shownotificaton(count: any) {
    const user_role = JSON.parse(this.user.user_role.user_roles)

    if (user_role.role_type != "Team_Lead") {

      this.count = "leave_request";
      this.addService.leaveNotify().then((value) => {
        this.notify = value.data
      })
    }
  }
  Loannotificaton(lonecount: any) {
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type != "Team_Lead") {
      this.lonecount = "loan_request";
      this.addService.loanNotify(this.lonecount).then((value) => {

        this.loannotification = value.data
      })
    }


  }


   isPayrollManagement(): boolean {
    
    const user_role = JSON.parse(this.user?.user_role.user_roles)
    if (user_role.role_type === "Employee") {
      return false
    } else {
      return user_role?.payroll?.payroll ?? false
    }
  }


  Attendancenotificaton(attendancecount: any) {
    this.user_role = JSON.parse(this.user.user_role.user_roles)
    if (this.user_role.role_type != "Team_Lead") {
      this.attendcount = "attendance_request";

      this.addService.attendanceNotify(this.attendcount).then((value) => {

        this.Attendanceotificaton = value.data
      })
    }
  }

  isAdmin(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role?.account_data.data.values.admin == true) {
      return true;
      // this.router.navigate(['/admin-accounts']);
    } else {
      // this.router.navigate(['/accounts-managment']);
      return false;
    }

  }
  isTeamMedia(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles)

    if (user_role.role_type === "Employee") {
      return false
    } else {
      return user_role.upload_data.upload_media ?? false
    }
  }

  toggleDropdown(): void {
    this.isDropdownVisible = !this.isDropdownVisible;
    this.isDropdownVisible ? this.addOutsideClickListener() : this.removeOutsideClickListener();
  }
  toggleorgDropdown(): void {
    this.isOrgdownVisible = !this.isOrgdownVisible;
    this.isOrgdownVisible ? this.addOutsideClickListener() : this.removeOutsideClickListener();
    this.getorgizations();
  }
  getorgizations() {
    this.showSpinner = true;
    this.dashboardService.getOrgnizations().then((value) => {
      this.orgnizations = value.data;
    })
    this.showSpinner = false;
  }


  async changeOrgnization(id: any) {
    this.showSpinner = true;

    try {
      const value = await this.dashboardService.changeOrgnization(id);

      if (value.success === true) {   // ✅ fixed comparison
        await Swal.fire({
          iconHtml: '<img src="../../../../assets/images/success-modal.svg" alt="image">',
          title: "OrganIzation Changed",
          showConfirmButton: false,
          timer: 1500,
        });

        window.location.reload();   // ✅ reload only after Swal closes
      } else {
        await Swal.fire({
          iconHtml: '<img src="../../../../assets/theme1/login-error.png" alt="image">',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } finally {
      this.showSpinner = false;
    }
  }





  hideDropdown(): void {
    this.isDropdownVisible = false;
    this.removeOutsideClickListener();
  }

  private addOutsideClickListener(): void {
    this.clickListener = this.renderer.listen('document', 'click', (event) => {
      const clickedInside = this.elementRef.nativeElement.contains(event.target);
      if (!clickedInside) this.hideDropdown();
    });
  }

  private removeOutsideClickListener(): void {
    if (this.clickListener) {
      this.clickListener();
      this.clickListener = null;
    }
  }

  ngOnDestroy(): void {
    this.removeOutsideClickListener();
  }
  user_refresh(): void {
    this.showSpinner = true;
    this.dashboardService.getuserrefresh().then((value) => {
      this.refresh = value.data.user;
      this.user = this.refresh;
      const userInfo = this.user;
      this.resignationapi = value.data.resign_status;
      this.resign_status = value.data.resign_status?.status ?? '';
      this.theme_id = userInfo?.theme_id
      if (this.theme_id === 2) {
        this.renderer.addClass(document.body, 'dark-theme');
      } else {
        this.renderer.removeClass(document.body, 'dark-theme');
      }
      if (userInfo != null) {
        this.user = this.user;
      }

      const todayDateObj = new Date();
      const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      const day = weekdays[todayDateObj.getDay()];

      const date = todayDateObj.getDate();
      const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      const month = months[todayDateObj.getMonth()];
      const year = todayDateObj.getFullYear();
      this.formattedDate = ` ${date} ${month}, ${year}`;

      this.showSpinner = false;
    }).catch((error) => {
      this.showSpinner = false;
    });

  }
  logout(): void {
    Swal.fire({
      iconHtml: '<img src="../../../../assets/images/success-modal.svg" alt="image">',
      title: 'Good Bye!',
      showConfirmButton: false,
      timer: 1500,
    });
    this.showSpinner = true;
    this.__logoutservice.logout().then((value) => {
      this.showSpinner = false;
      if (value.success === true) {
        this.router.navigate(['/']);
      }
    });
  }

  toggleSubList(event: MouseEvent) {
    event.stopPropagation();
    this.showSubList = !this.showSubList;
  }

  toggleOrgList(event: MouseEvent) {
    event.stopPropagation();
    this.showorgSubList = !this.showorgSubList;
  }

  sendValue(value: any) {
    this.showSpinner = true;
    localStorage.setItem('theme_id', value);
    this.sharedMode.setMode(value);

    this.dashboardService.changetheme(value).then((value) => {
      if (value.success = true) {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/theme1/login-error.png"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
      this.user_refresh();
      this.showSpinner = false;
      window.location.reload()
    })
  }


  toggleMenu(): void {
    this.isMenuVisible = !this.isMenuVisible;
  }

  toggleManagement(): void {
    this.isManagemntVisible = !this.isManagemntVisible;
  }


  setRouteleave(): string {
    this.theme_id
    if (this.theme_id == 1 || this.theme_id == 2) {
      return '/user-leaves-view';
    } else {
      return '/leaves';

    }
  }
  setRouteAttendance(): string {
    this.theme_id
    if (this.theme_id == 1 || this.theme_id == 2) {
      return '/user-attendance';
    } else {
      return '/attendance';

    }
  }

  getNotifiations() {
    this.showSpinner = true;
    const limit = 5;

    this.dashboardService.getNotification(limit)
      .then((value) => {
        
        this.notifylist = value?.data;
        // this.calculateTotalCount();
        this.totalCount = this.notifylist?.counts
        this.notify_counts = this.notifylist?.counts;
        this.notifyData = this.notifylist?.notifications;


      })
      .catch((error) => {
        console.error('Error loading notifications:', error);
      })
      .finally(() => {
        this.showSpinner = false;
      });

  }
  formatDate(dateString: string): string {
    
    const formattedDate = this.datePipe.transform(dateString, 'hh:mm a | dd MMMM, yyyy');
    return formattedDate ? formattedDate : '';
  }


  formatOnlyDate(dateString: string): string {
    const formattedDate = this.datePipe.transform(dateString, 'dd MMMM, yyyy');
    return formattedDate ? formattedDate : '';
  }

  // calculateTotalCount() {
  //   if (this.notifylist?.counts) {
  //     this.totalCount = Object.values(this.notifylist.counts).reduce((a: any, b: any) => a + b, 0);
  //   }
  // }


  isActionPermission() {
    const user_role = JSON.parse(this.user.user_role.user_roles)
    this.leaveaccept = user_role?.leave_data?.data?.values?.accept
    this.leaveReject = user_role?.leave_data?.data?.values?.reject


  }

  parseJson(jsonString: string): any {
    
    try {
      return JSON.parse(jsonString);
    } catch (e) {
      console.error('Error parsing JSON:', e);
      return null;
    }
  }


  toggleNotify() {
    this.isNotifyOpen = !this.isNotifyOpen;
  }



  clearnotify() {
    this.showSpinner = true;
    this.dashboardService.claerNotifications().then((value) => {
      // if (value.success = true) {
      //   Swal.fire({
      //     iconHtml:
      //       ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
      //     title: value.message,
      //     showConfirmButton: false,
      //     timer: 3000,
      //   });
      // } else {
      //   Swal.fire({
      //     iconHtml:
      //       ' <img src="../../../../assets/theme1/login-error.png"  alt="image" >',
      //     title: 'Get Error in Clear Notifications',
      //     showConfirmButton: false,
      //     timer: 3000,
      //   });
      // }
      this.showSpinner = false;
    })
  }


  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = this.dropdownRef?.nativeElement.contains(event.target);
    const bellClicked = (event.target as HTMLElement).closest('.notifications');

    if (!clickedInside && !bellClicked) {
      this.isNotifyOpen = false;
    }
  }


  clearnotifications(notify_id: any) {
    this.showSpinner = true;
    const id = notify_id;
    if (id != null) {
      this.dashboardService.notify(id).then((value) => {
        if (value.success = true) {
          // Swal.fire({
          //   iconHtml:
          //     ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          //   title: value.message,
          //   showConfirmButton: false,
          //   timer: 3000,
          // }).then(() => {
          // Navigate after modal closes
              window.location.reload()

        // });
        }
      })
    } else {
      Swal.fire({
        iconHtml:
          ' <img src="../../../../assets/theme1/login-error.png"  alt="image" >',
        title: 'Notification Id Did Not Found',
        showConfirmButton: false,
        timer: 3000,
      }).then(() => {
          // Navigate after modal closes
              window.location.reload()

        });
    }
    this.showSpinner = false;

  }

  socketRun() {
    this.socket.onRecievedNotification().subscribe(update => {
    });
  }




  approveleave(data: any) {
    this.showSpinner = true;
    let status;
    const user = JSON.parse(this.user.user_role.user_roles)
    const current_userrole1 = user?.role_type
    // If role is admin → Always Approve
    if (current_userrole1 === 'Admin') {
      status = 'approved';
    }
    // If role is teamlead
    if (current_userrole1 === 'Team_Lead' || current_userrole1 === 'Admin_AND_Team_Lead') {
      if (data.leave.approval_or_recommendation == 0) {
        status = 'recommended';
      } else if (data.leave.approval_or_recommendation == 1) {
        status = 'approved';
      }
    }

    const raw = data?.data
    const leavedata = JSON.parse(raw);
    const id = leavedata?.type_id
    this.notify_id = data?.req_notifications[0]?.notification_id
    this.leaveService.getLeaveApproved(id, status).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Leave Approved Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
      window.location.reload();

      this.showSpinner = false;
    });

  }
  rejectedReason = '';

  showRejectBox = false;
  leaveRejectionData: any;
  gettextauto: any;
  getTextForAutomation() {
    this.showSpinner = true;
    this.settings.getTextAuto().then((value) => {
      this.gettextauto = value?.data;
      this.leaveRejectionData = this.gettextauto.filter((item: any) => item.title.trim() === "LEAVE_REJECTION_TEXT");

      this.showSpinner = false;
    })
  }

  getApprovalButtonLabel(leave: any): string {
    const user = JSON.parse(this.user.user_role.user_roles)
    const current_userrole1 = user?.role_type
    // If role is admin → Always Approve
    if (current_userrole1 === 'Admin') {
      return 'Approve';
    }

    // If role is teamlead
    if (current_userrole1 === 'Team_Lead' || current_userrole1 === 'Admin_AND_Team_Lead') {
      if (leave.approval_or_recommendation == 0) {
        return 'Recommend';
      } else if (leave.approval_or_recommendation == 1) {
        return 'Approve';
      }
    }

    return 'Approve'; // default fallback
  }

  setReason(text: string) {
    this.rejectedReason = text;
  }

  // submitRejection(data: any) {
  //   if (this.rejectedReason.length >= 50) {

  //     // Add your API call or logic here
  //     // this.leaveService.rejectLeave(data.id, this.rejectedReason).subscribe(...)

  //     this.resetRejectionForm();
  //   }
  // }


  activeRejectId: number | null = null;

  toggleRejectBox(leaveId: number) {
    this.rejectedReason = '';
    this.activeRejectId = this.activeRejectId === leaveId ? null : leaveId;
  }
  reject() {
    // let id = this.rejected_leave_id;
    // let rejected_reason = reason.value.rejected_reason;
    const id = this.activeRejectId;
    const rejected_reason = this.rejectedReason;
    this.showSpinner = true;
    this.leaveService.rejectLeave(id, rejected_reason).then((value) => {
      // this.arr[this.rejected_leave_index].status = 'rejected';
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Leave Rejected Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      }
    });
  }
  isLeaveApprovedPermission(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type === "Employee") {
      return false
    } else if (user_role.role_type === "Team_Lead") {
      return false
    } else {
      return user_role.leave_data.data.values.accept
    }
  }
  isLeaveRejectPermission(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type === "Employee") {
      return false
    } else if (user_role.role_type === "Team_Lead") {
      return false
    } else {
      return user_role.leave_data.data.values.reject
    }
  }
  isUpdateLeavePermission(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type === "Employee") {
      return false
    } else if (user_role.role_type === "Team_Lead") {
      return false
    } else {
      return user_role.leave_data.data.values.update
    }
  }


  toggleSubMenu(event: MouseEvent) {
    event.stopPropagation();
    this.isSubMenuOpen = !this.isSubMenuOpen;
  }

  isActiveAttendanceManagement(): boolean {
    return this.router.url.includes('/attendance-management') || this.router.url.includes('/user-attendance-list');
  }

  isActiveAnnouncement(): boolean {
    return this.router.url.includes('/announcements') || this.router.url.includes('/add-announcement');
  }
  isActiveHolidays(): boolean {
    return this.router.url.includes('/holiday') || this.router.url.includes('/add-holiday');
  }
  isActiveEvent(): boolean {
    return this.router.url.includes('/event-management') || this.router.url.includes('/create-event');
  }
  isActiveLeaves(): boolean {
    return this.router.url.includes('/show-leaves') || this.router.url.includes('/leave-report');
  }
  isActiveEvaluation(): boolean {
    return this.router.url.includes('/evaluation-list') || this.router.url.includes('/all-users-evaluation');
  }
  isActiveTeamManagement(): boolean {
    return this.router.url.includes('/team-management') || this.router.url.includes('/employee-add');
  }

  setTodayAttendance() {
    this.showSpinner = true;
    this.dashboardService.todayAttendance().then((value) => {

    });
    this.router.navigate(['/attendance-management']);
    this.showSpinner = false;

  // this.showSpinner = true;

  // this.dashboardService.todayAttendance()
  //   .then(() => {
  //     this.router.navigate(['/attendance-management']);
  //   })
  //   .finally(() => {
  //     this.showSpinner = false;
  //   });

  }

  showUserDetails(data: any) {
    const uuid = data.uuid
    if (uuid != '' && uuid != null && uuid != undefined) {
      this.router.navigate(['/user-profile-view', uuid]);
    }
  }


  resetUserAuth() {
    this.showSpinner = true;
    this.settings.getauthReset().then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Authenticator Reset Successfully Now It Show QR Code',
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }


      this.showSpinner = false;
    })

  }

}
